import { DatabaseIdGenerator, initBinaryBlobFactory, initDataModelFactory, UnknownDataModelTypePolicy } from 'in-time-core';
import { BinaryBlobConverter } from './core/utils/binary-blob-converter';

export function initializeSerialization(options: { databaseIdGenerator: DatabaseIdGenerator }): void {
  const builders = new Map<string, unknown>();

  initDataModelFactory({
    customBuilders: builders,
    databaseIdGenerator: options.databaseIdGenerator,
    unknownTypePolicy: UnknownDataModelTypePolicy.Log,
  });

  initBinaryBlobFactory(new BinaryBlobConverter());
}
